import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { certificateInit, certificateDown, certificateLists } from 'api/payroll/prove-download';
import DownloadStaff from './download-staff';
// 部门
import Dep from '@/components/department';
// 部门列表
import JobSelect from '@/components/jobSelect';
export default {
  components: {
    Dep: Dep,
    JobSelect: JobSelect,
    DownloadStaff: DownloadStaff
  },
  data: function data() {
    return {
      form: {
        certificate_state: '',
        // 证明类型，1：在职证明，2：工资证明，3：就业证明
        department_id: '',
        // 部门
        job_title_id: '',
        // 职位
        search_name: '',
        // 工号、姓名、手机号
        page: 1,
        // 当前页
        page_size: 20,
        // 每页数量
        total: 0
      },
      // 批量下载loading
      mutipleLoading: false,
      // 批量下载
      mutipleSelect: [],
      certificateStates: [],
      // 证明类型
      tableColumn: [],
      // table 列
      tableData: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    certificateInit().then(function (res) {
      _this.certificateStates = res.data.certificate_state;
    });
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.page = val;
      this.getTableList();
    },
    // 获取表格信息
    getTableList: function getTableList() {
      var _this2 = this;
      certificateLists(this.form).then(function (res) {
        var _res$data = res.data,
          header = _res$data.header,
          body = _res$data.body,
          page_data = _res$data.page_data;
        _this2.tableColumn = header;
        _this2.tableData = body;
        _this2.form.total = page_data.total;
      });
    },
    // 表格选中
    handleSelectionChange: function handleSelectionChange(params) {
      this.mutipleSelect = params;
    },
    // 批量下载
    handleMutiple: function handleMutiple() {
      var _this3 = this;
      var staffs = this.mutipleSelect.map(function (item) {
        return item.staff_id;
      });
      this.mutipleLoading = true;
      certificateDown(_objectSpread({
        staff_id: staffs
      }, this.form)).then(function (res) {
        _this3.$message.success(res.message);
        _this3.$refs.table.clearSelection(false);
        _this3.mutipleSelect = [];
      }).finally(function () {
        return _this3.mutipleLoading = false;
      });
    },
    // 下载
    download: function download(row) {
      this.$refs.downloadStaff.init(row);
    },
    changeDep: function changeDep(params) {
      var depart = params[0];
      this.form.department_id = (depart === null || depart === void 0 ? void 0 : depart.department_id) || '';
    }
  }
};